var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('h1',[_vm._v("暂停服务")]),_c('h3',[_vm._v("网站已暂定服务，敬请期待！ ")])])
}]

export { render, staticRenderFns }